
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stream-microinverter",
      function () {
        return require("private-next-pages/stream-microinverter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stream-microinverter"])
      });
    }
  